// Our custom types

import type { SignalOn } from "@/types/signalr-functions.ts";
import { useSignalStore } from "@/stores/useSignalrStore.ts";
import { useEffect } from "react";
import type { EscapeHatchCallback } from "@/helpers/signalr/signalr.ts";

export const useSignalROn = (
  connection: SignalOn | string,
  callback: EscapeHatchCallback,
): void => {
  const { signalr } = useSignalStore();

  useEffect(() => {
    if (!signalr) {
      return;
    }

    const remove = signalr.On(connection, callback);

    return () => {
      remove.unwrapOr(() => {})();
    };
  }, [callback, connection, signalr]);
};
